import { getRequest } from '@/utils/axios'

export const getAccountOverview = params => {
  return getRequest('/api/accounts-overview', params)
}

export const getFundingMethod = params => {
  return getRequest('/api/funding-method', params)
}
export const getSupportDocument = params => {
  return getRequest('/api/supporting-document', params)
}
